import { api } from "@/common/lib/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CreateLotInput, Lot, LotsListResponse, UpdateLotInput } from "../types";

export function lotsQueryKey(accountId: string) {
  return ["lots", accountId] as const;
}

export function useLotsList(accountId: string) {
  return useQuery({
    queryKey: lotsQueryKey(accountId),
    queryFn: () => api.get<LotsListResponse>(`/accounts/${accountId}/lots`),
    enabled: Boolean(accountId),
  });
}

export function useCreateLot(accountId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateLotInput) => api.post<Lot>(`/accounts/${accountId}/lots`, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: lotsQueryKey(accountId) });
    },
  });
}

export function useUpdateLot(accountId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ lotId, input }: { lotId: string; input: UpdateLotInput }) =>
      api.patch<Lot>(`/accounts/${accountId}/lots/${lotId}`, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: lotsQueryKey(accountId) });
      void qc.invalidateQueries({ queryKey: ["animals", accountId] });
    },
  });
}
